import { BleClient, BleDevice } from '@capacitor-community/bluetooth-le';

import { ESPConstants } from './ESPConstants';
import { ESPDevice } from './ESPDevice';

/**
 * App can use this class to provision device. It has APIs to scan devices,
 * scan QR code and connect with the device to get object of ESPDevice.
 */
export class ESPProvisionManager {
    private static provision: ESPProvisionManager;

    private espDevice?: ESPDevice;

    /**
     * This method is used to get singleton instance of ESPProvisionManager
     *
     * @return Returns ESPProvisionManager instance
     */
    public static getInstance(): ESPProvisionManager {
        if (!this.provision) {
            this.provision = new ESPProvisionManager();
        }
        return this.provision;
    }

    /**
     * Initialize BLE
     *
     * @return Returns a Promise with void
     */
    public init(): Promise<void> {
        return BleClient.initialize();
    }

    /**
     * This method is used to get ESPDevice object with given transport and security.
     *
     * @param transportType Transport type.
     * @param securityType  Security type.
     *
     * @return Returns ESPDevice.
     */
    public createESPDevice(
        transportType: ESPConstants.TransportType,
        securityType: ESPConstants.SecurityType
    ) {
        this.espDevice = new ESPDevice(transportType, securityType);
        return this.espDevice;
    }

    /**
     * This method is used to get ESPDevice object with given transport and security.
     *
     * @return Returns ESPDevice.
     */
    public getEspDevice(): ESPDevice {
        return this.espDevice!;
    }

    /**
     * This method is used to destroy ESPDevice object.
     */
    public destroyESPDevice() {
        if (this.espDevice) {
            this.espDevice!.disconnectDevice();
            this.espDevice = undefined;
        }
    }

    /**
     * This method is used to scan BLE devices with having given prefix in device name.
     *
     * @param prefix Prefix to filter devices from device name.
     *
     * @return Returns Promise with BleDevice
     */
    public searchBleEspDevices(prefix: string = 'TIKO_'): Promise<BleDevice> {
        return BleClient.requestDevice({
            namePrefix: prefix,
            optionalServices: [ESPConstants.SERVICE_UUID], // This is required for web
        });
    }

    /**
     * This method is used to stop BLE scanning.
     */
    public stopBleScan(): Promise<void> {
        return BleClient.stopLEScan();
    }
}
